/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Empty_LegalInputs */

const cs_templates_empty_legal = /** @type {(inputs: Templates_Empty_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Žádné právní šablony.`)
};

const en_templates_empty_legal = /** @type {(inputs: Templates_Empty_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No legal templates yet.`)
};

/**
* | output |
* | --- |
* | "No legal templates yet." |
*
* @param {Templates_Empty_LegalInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_empty_legal = /** @type {((inputs?: Templates_Empty_LegalInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Empty_LegalInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_empty_legal(inputs)
	return cs_templates_empty_legal(inputs)
});